var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"default-chart",attrs:{"id":_vm.chartid}})}
var staticRenderFns = []

export { render, staticRenderFns }